const PSOrientationManager = require('./PSOrientationManager');

cc.Class({
    extends: cc.Component,

    onLoad () {
        this.orientationManager = cc.find('PSUIInitializer/PSUI/OrientationManager').getComponent(PSOrientationManager);

        if (this.orientationManager) {
            this.orientationManager.appendNode(this);
        }
    },

    start () {

    },

    onDestroy () {
        if (this.orientationManager) {
            this.orientationManager.removeNode(this);
        }
    },

    onLandscapeMobile () {

    },

    onPortraitMobile () {

    },

    onLandscapeDesktop () {

    },

    onPortraitDesktop () {

    },

});
